import type { SharedFormFieldProps } from '../types/formfield.types.js';

/**
 * @public
 */
export const enum FormFieldAction {
  UPDATE = 'update',
}

/**
 * @deprecated The FormField reducer is internal state — consumers should not
 * dispatch against it. This type and every field on it will be removed with
 * APPDEV-18318. Set `disabled` / `required` / `readOnly` / `aria-disabled` on
 * the form control directly, and pass `id` to the control rather than the
 * FormField.
 * @public
 */
export type FormFieldReducerActionPayload = {
  /** @deprecated Removed with APPDEV-18318. Pass `id` to the form control instead. */
  id?: string;
  /** @deprecated Removed with APPDEV-18318. Set on the form control directly. */
  disabled?: boolean;
  /** @deprecated Removed with APPDEV-18318. Set on the form control directly. */
  required?: boolean;
  /** @deprecated Removed with APPDEV-18318. Set `aria-disabled` on the form control directly. */
  ariaDisabled?: boolean;
  /** @deprecated Removed with APPDEV-18318. Set on the form control directly. */
  readOnly?: boolean;
};

/**
 * @deprecated The FormField reducer is internal state — consumers should not
 * dispatch against it. Removed with APPDEV-18318.
 * @public
 */
export type FormFieldReducerAction = {
  type: FormFieldAction.UPDATE;
  // eslint-disable-next-line @typescript-eslint/no-deprecated -- APPDEV-18321
  payload: FormFieldReducerActionPayload;
};

/**
 * @internal
 * FormField reducer function used for managing the FormField state.
 */
export function _formFieldReducer(
  state: SharedFormFieldProps,
  // eslint-disable-next-line @typescript-eslint/no-deprecated -- APPDEV-18321
  action: FormFieldReducerAction,
): SharedFormFieldProps {
  const { type, payload } = action;

  if (type === FormFieldAction.UPDATE) {
    return {
      ...state,
      required:
        // eslint-disable-next-line @typescript-eslint/no-deprecated -- APPDEV-18321
        payload.required !== undefined ? payload.required : state.required,
      disabled:
        // eslint-disable-next-line @typescript-eslint/no-deprecated -- APPDEV-18321
        payload.disabled !== undefined ? payload.disabled : state.disabled,
      ariaDisabled:
        // eslint-disable-next-line @typescript-eslint/no-deprecated -- APPDEV-18321
        payload.ariaDisabled !== undefined
          ? // eslint-disable-next-line @typescript-eslint/no-deprecated -- APPDEV-18321
            payload.ariaDisabled
          : state.ariaDisabled,
      readOnly:
        // eslint-disable-next-line @typescript-eslint/no-deprecated -- APPDEV-18321
        payload.readOnly !== undefined ? payload.readOnly : state.readOnly,
    };
  }

  return state;
}
